import React from 'react';
import LoginForm from '../components/Auth/LoginForm';
import '../styles/LoginPage.css';
import reanimeitorImage from '../Assets/reanimeitor-can.png.png';

const LoginPage = () => {
  return (
    <div className="login-page">
      {/* Efectos eléctricos de fondo */}
      <div className="energy-field-login">
        <div className="energy-bolt-login"></div>
        <div className="energy-bolt-login"></div>
        <div className="energy-bolt-login"></div>
        <div className="energy-bolt-login"></div>
        <div className="energy-node-login"></div>
        <div className="energy-node-login"></div>
        <div className="energy-node-login"></div>
        <div className="energy-node-login"></div>
      </div>

      {/* Layout principal: imagen izquierda + formulario derecha */}
      <div className="login-layout">
        {/* Columna izquierda - Imagen de la lata (solo escritorio) */}
        <div className="login-hero-column">
          <div className="login-hero-content">
            <div className="login-product-glow"></div>
            <div className="login-product-ring"></div>
            <img 
              src={reanimeitorImage} 
              alt="Reanimeitor Genesis Can" 
              className="login-product-image"
            />
            <div className="login-product-badge">
              <span className="badge-icon">⚡</span>
              <span>Reanimeitor</span>
            </div>
           
          </div>
        </div>

        {/* Columna derecha - Formulario de login */}
        <div className="login-form-column">
          <div className="login-welcome">
            <div className="login-logo">
              <span className="login-logo-icon">⚡</span>
              <span className="login-logo-text">REANIMEITOR</span>
            </div>
            <h1 className="welcome-title">Bienvenido de vuelta</h1>
            <p className="welcome-subtitle">
              Energiza tu experiencia cripto
            </p>
          </div>

          <LoginForm />

          <div className="login-features">
            <div className="feature-item">
              <div className="feature-icon">⚡</div>
              <p className="feature-text">Energía Instantánea</p>
            </div>
           
            <div className="feature-item">
              <div className="feature-icon">🚀</div>
              <p className="feature-text">Crecimiento Explosivo</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;